// eslint-disable-next-line import/no-extraneous-dependencies
import React, { MouseEventHandler, useEffect, useState } from 'react';
import { Destination } from '@wix/dashboard';
import { useDashboard } from './react';

export const PageLink = ({
  destination,
  onClick,
  children,
  ...otherHtmlProps
}: {
  destination: Destination;
  onClick?: React.AnchorHTMLAttributes<HTMLAnchorElement>['onClick'];
} & React.HTMLAttributes<HTMLElement>) => {
  const sdk = useDashboard();
  const [href, setHref] = useState<string>();

  useEffect(() => {
    let isEffectStillRelevant = true;
    const urlPromise = sdk.getPageUrl(destination);
    urlPromise.then((url) => isEffectStillRelevant && setHref(url));
    return () => {
      isEffectStillRelevant = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [destination]);

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (clickEvent) => {
    if (onClick) {
      onClick(clickEvent);
    }
    if (!clickEvent.defaultPrevented) {
      clickEvent.preventDefault();
      sdk.navigate(destination);
    }
  };

  return (
    <a {...otherHtmlProps} href={href} onClick={handleClick}>
      {children}
    </a>
  );
};
